import { Component, effect, input, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

import { startWith } from 'rxjs';

import { Media } from '@eiq/files/models';

@Component({
  standalone: true,
  selector: 'empathy-media-settings',
  templateUrl: 'media-settings.component.html',
  styleUrls: ['./media-settings.component.scss', './_media-settings-theme.component.scss'],
  imports: [FontAwesomeModule, MatFormFieldModule, MatInputModule, MatSlideToggle, MatTooltip, ReactiveFormsModule]
})
export class MediaSettingsComponent {
  activeQuestion = input<FormGroup>();

  hasPlayableMedia$ = signal(false);
  hasMultiplePlayableMedia$ = signal(false);

  faInfoCircle = faInfoCircle;

  constructor() {
    effect(
      (onCleanup) => {
        const form = this.activeQuestion();

        if (!form) {
          return;
        }

        const stimulusCtrl = form.get('stimulus');
        if (!stimulusCtrl) {
          return;
        }

        const sub = stimulusCtrl.valueChanges.pipe(startWith(stimulusCtrl.value)).subscribe((stimulus) => {
          const playableCount = this.getPlayableMediaCount(stimulus ?? []);

          this.hasPlayableMedia$.set(playableCount > 0);
          this.hasMultiplePlayableMedia$.set(playableCount > 1);
        });

        onCleanup(() => sub.unsubscribe());
      },
      { allowSignalWrites: true }
    );
  }

  private getPlayableMediaCount(stimulus: Media[] = []): number {
    return stimulus.filter((s) => {
      const type = s?.type;
      return type?.startsWith('video/') || type?.startsWith('audio/');
    }).length;
  }
}
